import { LocaleId, TranslationDictionaryMapping } from '@i18n';
import { FeatureCheckoutTranslationDictionary } from './feature-checkout-dictionary.interface';

export const translation: TranslationDictionaryMapping<FeatureCheckoutTranslationDictionary> =
  {
    [LocaleId.English_GreatBritain]: {
      PRICE_TAX_DISCLAIMER:
        'Price includes any applicable Insurance Premium Tax or VAT and is subject to any inflation and tax rate changes.',
      CONTACT_DETAILS_PAGE_TITLE: 'Confirm your contact details',
      CONTACT_DETAILS_PAGE_SUBTITLE: 'Your details',
      CONTACT_DETAILS_FORM_CONDITIONAL_EMAIL_REQUIRED:
        'Please enter an email address',
      CONTACT_DETAILS_FORM_EMAIL_VALID: 'Please enter a valid email address',
      CONTACT_DETAILS_FORM_EMAIL_MAX_LENGTH:
        'Please enter a value that is no more than 50 characters',
      CONTACT_DETAILS_FORM_PHONE_VALID: 'Please enter a valid phone number',
      CONTACT_DETAILS_FORM_CTA_CONFIRM_REGISTRATION: 'Confirm registration',
      CONTACT_DETAILS_FORM_CTA_CONTINUE_TO_PAYMENT: 'Continue to payment',
      CONTACT_DETAILS_FORM_POST_MARKETING_PREFERENCE:
        "We ({{ clientName }} and our warranty partner Domestic & General) would like to contact you by post from time to time with our latest news and offers. If you don't want to receive these, please tick this box.",
      CONTACT_DETAILS_FORM_EMAIL_MARKETING_PREFERENCE:
        'We ({{ clientName }} and our warranty partner Domestic & General) would like to contact you by email from time to time with our latest news and offers. If you want to receive these, please tick this box.',
      CONTACT_DETAILS_FORM_PHONE_MARKETING_PREFERENCE_NO_PURCHASE:
        "We would also like to contact you by phone, email, text and messaging apps with these offers. By giving us your details above, you agree you are happy to receive these messages. We'll look after your information and you can change your preferences at any time. Your details will only be used by us as described in the",
      CONTACT_DETAILS_FORM_PHONE_MARKETING_PREFERENCE_PURCHASE: `We would also like to contact you by phone with these offers. By giving us your details above, you agree you are happy to receive these calls. We'll look after your information and you can change your preferences at any time. Your details will only be used by us as described in the`,
      CONTACT_DETAILS_UPSELL_CHECKBOX_2MF_PROMO_BANNER:
        'Get your first 2 months protection FREE*. Cancel anytime',
      CONTACT_DETAILS_UPSELL_CHECKBOX_FOOTER_TITLE_PRICE:
        'for {{ price }} a month',
      CONTACT_DETAILS_UPSELL_CHECKBOX_FOOTER_TITLE_PRICE_ONE_OFF: '{{ price }}',
      CHECKOUT_PAGE_TITLE: 'Direct Debit Details',
      CHECKOUT_PAGE_SUBTITLE: 'Please provide your Direct Debit details below.',
      CHECKOUT_PAGE_MONTHLY_PAYMENT_LABEL_AND_PRICE:
        'Monthly payment: {{ price }} ',
      CHECKOUT_PAGE_MONTHLY_PAYMENT_PER_MONTH: 'a month unless cancelled.',
      CHECKOUT_DIRECT_DEBIT_FORM_ACCOUNT_NAME_REQUIRED:
        'Please enter the name of the account holder',
      CHECKOUT_DIRECT_DEBIT_FORM_ACCOUNT_NAME_MAX_LENGTH:
        'Please enter a value that is no more than 35 characters',
      CHECKOUT_DIRECT_DEBIT_FORM_ACCOUNT_NAME_ALPHABETICAL:
        'Please enter an alphabetical value',
      CHECKOUT_DIRECT_DEBIT_FORM_ACCOUNT_NUMBER_REQUIRED:
        'Please enter an account number',
      CHECKOUT_DIRECT_DEBIT_FORM_ACCOUNT_NUMBER_MIN_LENGTH:
        'Account number should contain 8 digits',
      CHECKOUT_DIRECT_DEBIT_FORM_ACCOUNT_NUMBER_VALID:
        'Please enter a valid account number',
      CHECKOUT_DIRECT_DEBIT_FORM_SORTCODE_REQUIRED: 'Please enter a sort code',
      CHECKOUT_DIRECT_DEBIT_FORM_SORTCODE_MIN_LENGTH:
        'Sort code should contain 6 digits',
      CHECKOUT_DIRECT_DEBIT_FORM_SORTCODE_VALID:
        'Please enter a valid sort code',
      CHECKOUT_DIRECT_DEBIT_FORM_PAYMENT_DATE_REQUIRED:
        'Please enter a payment date',
      CHECKOUT_DIRECT_DEBIT_FORM_ACCOUNT_HOLDER_CONFIRMATION_REQUIRED_TRUE:
        'Please check the box to confirm that your information is correct',
      CHECKOUT_DIRECT_DEBIT_FORM_TERMS_AND_CONDITIONS_REQUIRED_TRUE:
        'Please tick the box to confirm you have read the Insurance Product Information Document',
      CHECKOUT_DIRECT_DEBIT_FORM_PAYMENT_DETAILS_VALIDATION_ERROR:
        'There was a problem processing your payment. Please check your card details and try again',
      CHECKOUT_DIRECT_DEBIT_FORM_LEGAL_GUARANTEE_TITLE:
        'The Direct Debit Guarantee',
      CHECKOUT_DIRECT_DEBIT_FORM_LEGAL_COVER_START_TITLE: 'Cover start date',
      CHECKOUT_DIRECT_DEBIT_FORM_LEGAL_COVER_START_DESCRIPTION_ONE:
        'As your appliance is in guarantee, cover will start once we have processed your application. This is normally done within 24 hours of purchase. The policy provides continuous cover, so payments will be taken monthly for as long as you like.',
      CHECKOUT_DIRECT_DEBIT_FORM_LEGAL_COVER_START_DESCRIPTION_ONE_OOG:
        'As your appliance is out of guarantee, cover will start after a 30 day wait. The policy provides continuous cover, so payments will be taken monthly for as long as you like.',
      CHECKOUT_DIRECT_DEBIT_FORM_LEGAL_COVER_START_DESCRIPTION_ONE_MULTI_PLAN:
        ' Your cover will start once we have processed your application. This is normally done within 24 hours of purchase. The policy provides continuous cover, so payments will be taken monthly for as long as you like.',
      CHECKOUT_DIRECT_DEBIT_FORM_LEGAL_COVER_TERMS_AND_CONDITIONS_TITLE:
        'Terms and Conditions*',
      CHECKOUT_DIRECT_DEBIT_FORM_LEGAL_COVER_TERMS_AND_CONDITIONS_DESCRIPTION_ONE:
        'This insurance policy is designed to meet the demands and needs of those who wish to insure their electronic appliances and/or household goods against breakdown and accidental damage. Full details on how to submit a complaint can be found in the',
      CHECKOUT_DIRECT_DEBIT_FORM_LEGAL_COVER_TERMS_AND_CONDITIONS_LINK_TCS_TEXT:
        'Appliance Care Terms & Conditions',
      CHECKOUT_DIRECT_DEBIT_FORM_LEGAL_COVER_TERMS_AND_CONDITIONS_DESCRIPTION_TWO_PREFIX:
        'You must read the',
      CHECKOUT_DIRECT_DEBIT_FORM_LEGAL_COVER_TERMS_AND_CONDITIONS_LINK_IPID_TEXT:
        'Appliance Care Insurance Product Information Document',
      CHECKOUT_DIRECT_DEBIT_FORM_LEGAL_COVER_TERMS_AND_CONDITIONS_DESCRIPTION_TWO_SUFFIX:
        'before purchase. You must be at least 18 years old to buy this policy.',
      CHECKOUT_DIRECT_DEBIT_FORM_PAPERLESS_LABEL:
        'Paperless documents (optional)',
      CHECKOUT_DIRECT_DEBIT_FORM_PAPERLESS_DESCRIPTION:
        "Going paperless means there's less post to deal with, file or recycle, so we send all your policy documents via email.",
      CHECKOUT_DIRECT_DEBIT_FORM_CTA: 'Confirm and pay securely',
      CHECKOUT_DIRECT_DEBIT_FORM_LINK_GO_BACK: 'Back',
      STEP_TITLE_YOUR_DETAILS: 'Your details',
      STEP_TITLE_YOUR_PAYMENT_DETAILS: 'Your payment details',
      CONTACT_DETAILS_FORM_EMAIL_HINT:
        'We will send your documents to this email address',
      CONTACT_DETAILS_FORM_PHONE_HINT:
        "We'll get in touch if we need to arrange repairs or replacements",
      CONTACT_DETAILS_PAGE_BACK_LABEL: 'Back',
    },
    [LocaleId.English_Ireland]: {
      PRICE_TAX_DISCLAIMER:
        'Price includes any applicable Insurance Premium Tax or VAT and is subject to any inflation and tax rate changes.',
      CONTACT_DETAILS_PAGE_TITLE: 'Confirm your contact details',
      CONTACT_DETAILS_PAGE_SUBTITLE: 'Your details',
      CONTACT_DETAILS_FORM_CONDITIONAL_EMAIL_REQUIRED:
        'Please enter an email address',
      CONTACT_DETAILS_FORM_EMAIL_VALID: 'Please enter a valid email address',
      CONTACT_DETAILS_FORM_EMAIL_MAX_LENGTH:
        'Please enter a value that is no more than 50 characters',
      CONTACT_DETAILS_FORM_PHONE_VALID: 'Please enter a valid phone number',
      CONTACT_DETAILS_FORM_CTA_CONFIRM_REGISTRATION: 'Confirm registration',
      CONTACT_DETAILS_FORM_CTA_CONTINUE_TO_PAYMENT: 'Continue to payment',
      CONTACT_DETAILS_FORM_POST_MARKETING_PREFERENCE:
        "We ({{ clientName }} and our warranty partner Domestic & General) would like to contact you by post from time to time with our latest news and offers. If you don't want to receive these, please tick this box.",
      CONTACT_DETAILS_FORM_EMAIL_MARKETING_PREFERENCE:
        'We ({{ clientName }} and our warranty partner Domestic & General) would like to contact you by email from time to time with our latest news and offers. If you want to receive these, please tick this box.',
      CONTACT_DETAILS_FORM_PHONE_MARKETING_PREFERENCE_NO_PURCHASE:
        "We would also like to contact you by phone, email, text and messaging apps with these offers. By giving us your details above, you agree you are happy to receive these messages. We'll look after your information and you can change your preferences at any time. Your details will only be used by us as described in the",
      CONTACT_DETAILS_FORM_PHONE_MARKETING_PREFERENCE_PURCHASE: `We would also like to contact you by phone with these offers. By giving us your details above, you agree you are happy to receive these calls. We'll look after your information and you can change your preferences at any time. Your details will only be used by us as described in the`,
      CONTACT_DETAILS_UPSELL_CHECKBOX_2MF_PROMO_BANNER:
        'Get your first 2 months protection FREE*. Cancel anytime',
      CONTACT_DETAILS_UPSELL_CHECKBOX_FOOTER_TITLE_PRICE:
        'for {{ price }} a month',
      CONTACT_DETAILS_UPSELL_CHECKBOX_FOOTER_TITLE_PRICE_ONE_OFF: '{{ price }}',
      CHECKOUT_PAGE_TITLE: 'Direct Debit Details',
      CHECKOUT_PAGE_SUBTITLE: 'Please provide your Direct Debit details below.',
      CHECKOUT_PAGE_MONTHLY_PAYMENT_LABEL_AND_PRICE:
        'Monthly payment: {{ price }} ',
      CHECKOUT_PAGE_MONTHLY_PAYMENT_PER_MONTH: 'a month unless cancelled.',
      CHECKOUT_DIRECT_DEBIT_FORM_ACCOUNT_NAME_REQUIRED:
        'Please enter the name of the account holder',
      CHECKOUT_DIRECT_DEBIT_FORM_ACCOUNT_NAME_MAX_LENGTH:
        'Please enter a value that is no more than 35 characters',
      CHECKOUT_DIRECT_DEBIT_FORM_ACCOUNT_NAME_ALPHABETICAL:
        'Please enter an alphabetical value',
      CHECKOUT_DIRECT_DEBIT_FORM_ACCOUNT_NUMBER_REQUIRED:
        'Please enter an account number',
      CHECKOUT_DIRECT_DEBIT_FORM_ACCOUNT_NUMBER_MIN_LENGTH:
        'Account number should contain 8 digits',
      CHECKOUT_DIRECT_DEBIT_FORM_ACCOUNT_NUMBER_VALID:
        'Please enter a valid account number',
      CHECKOUT_DIRECT_DEBIT_FORM_SORTCODE_REQUIRED: 'Please enter a sort code',
      CHECKOUT_DIRECT_DEBIT_FORM_SORTCODE_MIN_LENGTH:
        'Sort code should contain 6 digits',
      CHECKOUT_DIRECT_DEBIT_FORM_SORTCODE_VALID:
        'Please enter a valid sort code',
      CHECKOUT_DIRECT_DEBIT_FORM_PAYMENT_DATE_REQUIRED:
        'Please enter a payment date',
      CHECKOUT_DIRECT_DEBIT_FORM_ACCOUNT_HOLDER_CONFIRMATION_REQUIRED_TRUE:
        'Please check the box to confirm that your information is correct',
      CHECKOUT_DIRECT_DEBIT_FORM_TERMS_AND_CONDITIONS_REQUIRED_TRUE:
        'Please tick the box to confirm you have read the Insurance Product Information Document',
      CHECKOUT_DIRECT_DEBIT_FORM_PAYMENT_DETAILS_VALIDATION_ERROR:
        'There was a problem processing your payment. Please check your card details and try again',
      CHECKOUT_DIRECT_DEBIT_FORM_LEGAL_GUARANTEE_TITLE:
        'The Direct Debit Guarantee',
      CHECKOUT_DIRECT_DEBIT_FORM_LEGAL_COVER_START_TITLE: 'Cover start date',
      CHECKOUT_DIRECT_DEBIT_FORM_LEGAL_COVER_START_DESCRIPTION_ONE:
        'As your appliance is in guarantee, cover will start once we have processed your application. This is normally done within 24 hours of purchase. The policy provides continuous cover, so payments will be taken monthly for as long as you like.',
      CHECKOUT_DIRECT_DEBIT_FORM_LEGAL_COVER_START_DESCRIPTION_ONE_OOG:
        'As your appliance is out of guarantee, cover will start after a 30 day wait. The policy provides continuous cover, so payments will be taken monthly for as long as you like.',
      CHECKOUT_DIRECT_DEBIT_FORM_LEGAL_COVER_START_DESCRIPTION_ONE_MULTI_PLAN:
        ' Your cover will start once we have processed your application. This is normally done within 24 hours of purchase. The policy provides continuous cover, so payments will be taken monthly for as long as you like.',
      CHECKOUT_DIRECT_DEBIT_FORM_LEGAL_COVER_TERMS_AND_CONDITIONS_TITLE:
        'Terms and Conditions*',
      CHECKOUT_DIRECT_DEBIT_FORM_LEGAL_COVER_TERMS_AND_CONDITIONS_DESCRIPTION_ONE:
        'This insurance policy is designed to meet the demands and needs of those who wish to insure their electronic appliances and/or household goods against breakdown and accidental damage. Full details on how to submit a complaint can be found in the',
      CHECKOUT_DIRECT_DEBIT_FORM_LEGAL_COVER_TERMS_AND_CONDITIONS_LINK_TCS_TEXT:
        'Appliance Care Terms & Conditions',
      CHECKOUT_DIRECT_DEBIT_FORM_LEGAL_COVER_TERMS_AND_CONDITIONS_DESCRIPTION_TWO_PREFIX:
        'You must read the',
      CHECKOUT_DIRECT_DEBIT_FORM_LEGAL_COVER_TERMS_AND_CONDITIONS_LINK_IPID_TEXT:
        'Appliance Care Insurance Product Information Document',
      CHECKOUT_DIRECT_DEBIT_FORM_LEGAL_COVER_TERMS_AND_CONDITIONS_DESCRIPTION_TWO_SUFFIX:
        'before purchase. You must be at least 18 years old to buy this policy.',
      CHECKOUT_DIRECT_DEBIT_FORM_PAPERLESS_LABEL: 'Paperless documents',
      CHECKOUT_DIRECT_DEBIT_FORM_PAPERLESS_DESCRIPTION:
        "Going paperless means there's less post to deal with, file or recycle, so we send all your policy documents via email.",
      CHECKOUT_DIRECT_DEBIT_FORM_CTA: 'Confirm and pay securely',
      CHECKOUT_DIRECT_DEBIT_FORM_LINK_GO_BACK: 'Back',
      STEP_TITLE_YOUR_DETAILS: 'Your details',
      STEP_TITLE_YOUR_PAYMENT_DETAILS: 'Your payment details',
      CONTACT_DETAILS_FORM_EMAIL_HINT:
        'We will send your documents to this email address',
      CONTACT_DETAILS_FORM_PHONE_HINT:
        "We'll get in touch if we need to arrange repairs or replacements",
      CONTACT_DETAILS_PAGE_BACK_LABEL: 'Back',
    },
  };
